export default __webpack_public_path__ + "static/Robotic-b366e1d31c3de4c6ae1194a6652dad2a.jpg";